<script setup lang="ts">
import { useRouter } from 'vue-router';

import ReferralGiftIcon from './ReferralGiftIcon.vue';

const router = useRouter();

const handleClick = () => {
  return router.push('/referral');
};
</script>
<template>
  <button
    type="button"
    class="h-10 min-w-10 rounded-lg border border-warning-300 bg-warning-100 text-warning-500"
    :title="$t('layout.navBar.referral')"
    @click="handleClick"
  >
    <ReferralGiftIcon size="sm" class="translate-x-1.5 translate-y-0.5" />
  </button>
</template>
